<template>
  <div ref="trgt">
    <div class="container" v-if="error">
      <div class="message is-warning">
        <div class="message-body">
          <p v-html="error"></p>
          <!-- <pre>{{ error }}</pre> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { get } from "@/utils";

export default {
  name: "ModuleTechnicalDocs",
  components: {},
  data() {
    return {
      error: null,
    };
  },
  methods: {
    retrieve_docs() {
      let v = this;
      v.$root.loader(true);
      get("/module/technical-docs", {
        code_name: this.$route.params.code_name,
      })
        .then((response) => {
          // Clear the target div
          v.$refs.trgt.innerHTML = "";
          // This response is HTML content, css and js. Create an iframe and put it into trgt div
          let iframe = document.createElement("iframe");
          iframe.srcdoc = response;
          iframe.style.width = "100%";
          iframe.style.height = "100vh";
          iframe.style.border = "none";
          v.$refs.trgt.appendChild(iframe);
          // Add a class to the iframe for styling
          iframe.classList.add("technical-docs-iframe");
          // Add a listener to the iframe to resize it when the content changes
          iframe.addEventListener("load", () => {
            iframe.style.height =
              iframe.contentWindow.document.body.scrollHeight + "px";
          });
          // Resize the iframe when the window is resized
          window.addEventListener("resize", () => {
            iframe.style.height =
              iframe.contentWindow.document.body.scrollHeight + "px";
          });
        })
        .catch((error) => {
          console.error(error);
          /** If error 404, print data */
          if (error.data) v.error = error.data;
          else v.error = JSON.stringify(error);
        })
        .finally(() => {
          v.$root.loader(false);
        });
    },
  },
  mounted() {
    this.error = null;
    this.retrieve_docs();
  },
  created() {},
};
</script>

<style scoped></style>
